(function () {
  'use strict';

  const TRANSITION_MS = 250;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function setPanelClosed(panel) {
    panel.style.height = '0px';
    panel.style.overflow = 'hidden';
    panel.style.transition = '';
  }

  function setPanelOpen(panel) {
    panel.style.height = 'auto';
    panel.style.overflow = '';
    panel.style.transition = '';
  }

  function openAccordion(details, panel) {
    if (prefersReducedMotion()) {
      details.open = true;
      setPanelOpen(panel);
      return;
    }

    details.open = true;
    details.classList.add('is-animating');

    const targetHeight = panel.scrollHeight;
    panel.style.overflow = 'hidden';
    panel.style.height = '0px';
    panel.offsetHeight;
    panel.style.transition = 'height ' + TRANSITION_MS + 'ms ease-in-out';
    panel.style.height = targetHeight + 'px';

    panel.addEventListener('transitionend', function onEnd(event) {
      if (event.target !== panel || event.propertyName !== 'height') {
        return;
      }

      panel.removeEventListener('transitionend', onEnd);
      setPanelOpen(panel);
      details.classList.remove('is-animating');
    });
  }

  function closeAccordion(details, panel) {
    if (prefersReducedMotion()) {
      details.open = false;
      setPanelClosed(panel);
      return;
    }

    details.classList.add('is-animating');

    const currentHeight = panel.scrollHeight;
    panel.style.overflow = 'hidden';
    panel.style.height = currentHeight + 'px';
    panel.offsetHeight;
    panel.style.transition = 'height ' + TRANSITION_MS + 'ms ease-in-out';
    panel.style.height = '0px';

    panel.addEventListener('transitionend', function onEnd(event) {
      if (event.target !== panel || event.propertyName !== 'height') {
        return;
      }

      panel.removeEventListener('transitionend', onEnd);
      details.open = false;
      details.classList.remove('is-animating');
      setPanelClosed(panel);
    });
  }

  function bindAccordion(details) {
    if (details.dataset.accordionBound === 'true') {
      return;
    }

    const summary = details.querySelector('summary');
    const panel = details.querySelector('.accordion__panel');

    if (!summary || !panel) {
      return;
    }

    details.dataset.accordionBound = 'true';

    if (details.open) {
      setPanelOpen(panel);
    } else {
      setPanelClosed(panel);
    }

    summary.addEventListener('click', function (event) {
      event.preventDefault();

      if (details.classList.contains('is-animating')) {
        return;
      }

      if (details.open) {
        closeAccordion(details, panel);
        return;
      }

      openAccordion(details, panel);
    });
  }

  function boot() {
    document.querySelectorAll('details[data-accordion]').forEach(bindAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
